import { DestroyRef, Injectable, inject, signal } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { OpenConfirmationModalService } from '@vendasta/galaxy/confirmation-modal';
import { UnsavedChangesService } from '../interface';

@Injectable()
export class EmailBuilderUnsavedChangesService implements UnsavedChangesService {
  private readonly confirmationModal = inject(OpenConfirmationModalService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly unsavedChanges = signal(false);

  constructor() {
    this.setUpWarnTabExitWithUnsavedChanges();
  }

  private setUpWarnTabExitWithUnsavedChanges(): void {
    window.addEventListener('beforeunload', this.warnBeforeUnload);
    this.destroyRef.onDestroy(() => window.removeEventListener('beforeunload', this.warnBeforeUnload));
  }

  setUnsavedChanges(hasUnsavedChanges: boolean): void {
    this.unsavedChanges.set(hasUnsavedChanges);
  }

  confirmNavigation(): Observable<boolean> {
    if (!this.unsavedChanges()) {
      return of(true);
    }
    return this.confirmationModal
      .openModal({
        type: 'warn',
        title: 'CONTENT_BUILDER.UNSAVED_CHANGES.TITLE',
        message: 'CONTENT_BUILDER.UNSAVED_CHANGES.MESSAGE',
        confirmButtonText: 'CONTENT_BUILDER.UNSAVED_CHANGES.CONFIRM',
        cancelButtonText: 'CONTENT_BUILDER.UNSAVED_CHANGES.CANCEL',
      })
      .pipe(map((confirmed) => !!confirmed));
  }

  canDeactivate(): Observable<boolean> {
    return this.confirmNavigation();
  }

  private readonly warnBeforeUnload = (event: BeforeUnloadEvent): void => {
    if (this.unsavedChanges()) {
      event.preventDefault();
      event.returnValue = '';
    }
  };
}
